import type { SxProps, Theme } from '@mui/material';

/** Expand chevron on the left (income journey, bank-credit payor groups, etc.). */
export const accordionSummaryExpandLeftSx: SxProps<Theme> = {
  flexDirection: 'row',
  '& .MuiAccordionSummary-expandIconWrapper': {
    order: 0,
    marginLeft: 0,
    marginRight: 1,
  },
  '& .MuiAccordionSummary-content': {
    order: 1,
    marginRight: 0,
  },
};
